export const GUEST = 'Guest'
export const ADMIN = 'Admin'
